import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import my2 from "../assets/Images/appu-pic.png";

/* ================= MAIN BOX ================= */

const Box = styled(motion.div)`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  width: 65vw;
  height: 55vh;
  display: flex;

  background: linear-gradient(
      to right,
      ${props => props.theme.body} 50%,
      ${props => props.theme.text} 50%
    )
    bottom,
    linear-gradient(
      to right,
      ${props => props.theme.body} 50%,
      ${props => props.theme.text} 50%
    )
    top;

  background-repeat: no-repeat;
  background-size: 100% 2px;

  border-left: 2px solid ${props => props.theme.body};
  border-right: 2px solid ${props => props.theme.text};

  z-index: 5;

  /* MOBILE ONLY */
@media (max-width: 425px) {
  flex-direction: column;

  width: 192px;       /* EXACT WIDTH */
  height: 356px;      /* EXACT HEIGHT */

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  
    background: linear-gradient(
    to bottom,
    #000 50%,
    #FCF6F4 50%
  );

    border: 2px solid #fff;

    &::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50%;
  border-left: 2px solid #000;
  border-right: 2px solid #000;
  border-bottom: 2px solid #000;
  pointer-events: none;
}
}

@media (min-width: 425px) and (max-width: 768px) {
  width: 70vw;
  height: 52vh;
}
`;

/* ================= SUB BOX ================= */

const SubBox = styled.div`
  width: 50%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

 @media (max-width: 425px) {
    width: 100%;
    padding: 0;
    height: 50%;
  }

  /* TABLET FIX */
  @media (min-width:425px) and (max-width:768px){
    width:50%;
    height:100%;
    display:flex;
    align-items:center;
    justify-content:center;
  }


`;

/* ================= IMAGE ================= */

const ProfileImage = styled(motion.img)`
  height: 100%;
  width: auto;
  object-fit: contain;
  transform: scale(1);

  display: block;

  @media (max-width: 424px) {
    height: 200px;
    width: auto;
    position: absolute;
    bottom: 0;
  }

  /* 425px → 768px FIX */
  @media (min-width: 425px) and (max-width: 768px) {
    height: 100%;
    width: auto;
    object-fit: contain;
    position: relative;
  }
`;

/* ================= TEXT ================= */

const Text = styled.div`
  font-size: calc(1em + 1.5vw);
  color: ${props => props.theme.body};
  padding: 2rem;

  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  & > *:last-child {
    color: ${props => `rgba(${props.theme.bodyRgba},0.6)`};
    font-size: calc(0.5rem + 1.5vw);
    font-weight: 300;
  }

  /* 📱 MOBILE TEXT SIZE */
  @media (max-width: 425px) {
    font-size: 1.3rem;
    padding: 1rem;
    text-align: center;
    justify-content: center;
  }
`;

/* ================= COMPONENT ================= */

const Intro = () => {
  return (
<Box
  initial={{ height: 0 }}
  animate={{ height: "55vh" }}
  transition={{ type: "spring", duration: 2, delay: 1 }}
>
  <SubBox>
    <Text>
      <h1>Hi,</h1>
      <h3>I'm Raja Retnam</h3>
      <h6>I design and Code simple yet beautiful websites.</h6>
    </Text>
  </SubBox>

  <SubBox className="image-section">
    <ProfileImage
      src={my2}
      alt="Profile Pic"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, delay: 2 }}
    />
  </SubBox>
</Box>
  );
};

export default Intro;